module.exports = __webpack_public_path__ + "assets/img/block-left-c0ef188a.png";